import FeatureUnavailableDialog from '@common-components/tasks-panel/feature-unavailable-dialog/feature-unavailable-dialog';
import ImportExcelToBlueticks from '@common-components/tasks-panel/import-tasks-from-excel/import-excel';
import NewBoardDialog from '@common-components/tasks-panel/new-board-dialog/new-board-dialog';
import { bulkActions } from '@common-reducers/BulkActionsReducer';
import { importItemsActions } from '@common-reducers/ImportItemsReducer';
import { MODAL, modalActions } from '@common-reducers/ModalReducer';
import { useAppDispatch, useAppSelector } from '@common-reducers/hooks/store.hook';
import UpdateDetailsModal from '@common-views/account-view/update-details-modal';
import { InviteToWorkSpace } from '@common-views/user-management/invite-to-work-space';
import { useEffect } from 'react';
import ExportExcel from '../tasks-panel/export-tasks-and-groups/export-to-excel';
import ContactWorkSpaceAdmin from './contact-workspace-admin';
import ConfirmEmail from './email-confirmation-modal';
import ConfirmEmailThankYou from './email-confirmation-thankyou-modal';
import TrialModal from './trial-modal';
import TrialModalActivateAnimation from './trial-modal-activate-animation';
import { appConfig } from '@common/config/app.config';
import { DeleteAccountModal } from './delete-account-modal';
import { UpdateSubscriptionWorkSpace } from './update-subscription-workspace';
import { Dialog, DialogContent } from '@/components/ui/dialog';


export default function ReusableModal() {
    const dispatch = useAppDispatch()

    const openedby = useAppSelector((state) => state.ModalReducer.openedby)
    const componentToRender = useAppSelector((state) => state.ModalReducer.component)
    const animationComponent = useAppSelector((state) => state.ModalReducer.animationComponent)
    const previousComponentToRender = useAppSelector((state) => state.ModalReducer.previousComponentToRender)


    useEffect(() => {
        if (componentToRender === "") {
            dispatch(importItemsActions.resetImport())
            //handleClose()
        }
    }, [componentToRender, dispatch])


    function handleClose() {
        dispatch(modalActions.setImportType(''));
        dispatch(bulkActions.setBulkTasksMap({}))
        dispatch(modalActions.setOpenedby(''))
        dispatch(importItemsActions.setNewAudienceName(null));
        if (componentToRender === MODAL.EMAIL_CONFIRMATION) {
            localStorage.setItem('modal_email_confirm', new Date().toISOString())
        }
        if (componentToRender !== MODAL.TRIAL_START) {
            dispatch(modalActions.setComponentToRender(''))
        }
    }

    const isOpen = componentToRender !== "";
    const maxWidth = openedby === 'campaign' ? 'max-w-[85vw]' : 'max-w-[600px]';
    const padding = componentToRender === MODAL.IMPORT_EXCEL_TO_BLUETICKS ? 'p-0' : 'p-6';

    return (
        <>
            <Dialog open={isOpen} onOpenChange={(open) => !open && handleClose()}>
                <DialogContent 
                    className={`${maxWidth} ${padding} w-full`}
                    style={{
                        backgroundColor: 'var(--color-surface, #ffffff)',
                        color: 'var(--color-text, #111827)',
                    }}
                >
                    {componentToRender === MODAL.EXPORT_TO_EXCEL && <ExportExcel />}
                    {componentToRender === MODAL.IMPORT_EXCEL_TO_BLUETICKS && <ImportExcelToBlueticks />}
                    {componentToRender === MODAL.NEW_BOARD && <NewBoardDialog />}
                    {componentToRender === MODAL.FEATURE_NOT_AVAILABLE && <FeatureUnavailableDialog />}
                    {componentToRender === MODAL.COMPLETE_PROFILE && <UpdateDetailsModal />}
                    {componentToRender === MODAL.INVITE_TO_WORKSPACE && <InviteToWorkSpace />}
                    {componentToRender === MODAL.DELETE_ACCOUNT && <DeleteAccountModal />}
                    {componentToRender === MODAL.UPDATE_SUBSCRIPTION_WORKSPACE && <UpdateSubscriptionWorkSpace />}
                    
                    {(appConfig.asset_key === 'tudoboard') && <>
                        {componentToRender === MODAL.EMAIL_CONFIRMATION && <ConfirmEmail />}
                        {componentToRender === MODAL.EMAIL_CONFIRMATION_THANKS && <ConfirmEmailThankYou />}
                        {(componentToRender === MODAL.TRIAL_START || previousComponentToRender === MODAL.TRIAL_START) && <TrialModal />}
                    </>}
                    {componentToRender === MODAL.CONTACT_WORKSPACE_ADMIN && <ContactWorkSpaceAdmin />}
                </DialogContent>
            </Dialog>

            {animationComponent === 'TrialModalActivateAnimation' && <TrialModalActivateAnimation />}
        </>
    );
}
